import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { shareReplay, switchMap, tap } from 'rxjs/operators';
import { CampaignCapWindow } from './campaign-cap-window';

@Injectable({
    providedIn: 'root'
})
export class CampaignCapWindowService {
    private readonly routePrefix: string = '/api/campaigncapwindow/';
    private refresh = new BehaviorSubject<void>(undefined);

    constructor(private http: HttpClient) { }

    getCampaignCapWindows = () => this.refresh.pipe(
        switchMap(() => this.http.get<CampaignCapWindow[]>(`${this.routePrefix}`).pipe(
            tap(data => {
                for (const capWindow of data) {
                    capWindow.beginDate = new Date(capWindow.beginDateString);
                    capWindow.endDate = new Date(capWindow.endDateString);
                }
            }),
        )),
        shareReplay(1),
    )

    refreshData(): void {
        this.refresh.next();
    }

    saveCampaignCapWindow = (campaignCapWindow: CampaignCapWindow) => this.http.post<number>(`${this.routePrefix}`, campaignCapWindow);

    deleteCampaignCapWindow = (campaignCapWindow: CampaignCapWindow) => this.http.delete(`${this.routePrefix}${campaignCapWindow.campaignCapWindowId}`);

    getCapAmount = () => this.http.get<number>(`${this.routePrefix}capamount`);
}
